import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Router } from '@angular/router';

@Component({
    selector: 'info-message',
    templateUrl: './info-message.component.html',
    styleUrls: ['./info-message.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger(
            'leaveAnimation', [
            transition(':leave', [
                style({ opacity: 1 }),
                animate('500ms', style({ opacity: 0 })),
            ]),
        ],
        ),
    ],
})
export class InfoMessageComponent implements OnDestroy {
    @Input() public text;
    @Input() public buttonText: string;
    @Input() public show: boolean;
    @Input() public showIcon: boolean = true;
    @Input() public showButton: boolean = false;
    @Input() public showCloseButton: boolean = false;
    @Input() public closeAction: () => void;
    @Input() public injectFunction: (args: any) => void;

    constructor(private router: Router) { }

    ngOnDestroy() { }
}
